import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-device-coverage',
  templateUrl: './device-coverage.component.html',
  styleUrls: ['./device-coverage.component.scss']
})
export class DeviceCoverageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
